import { watch } from "vue";
import { useQuizStore } from "../stores/quizStore";
import { collectImageUrlsFromSlide, preloadImage } from "../utils/imagePreload";

export function useSlidePreload() {
    const quiz = useQuizStore();

    watch(
        () => quiz.currentIndex,
        (index) => {
            if (index == null || index < 0) return;
            const allSlides = quiz.slides;

            for (let offset = 1; offset <= 2; offset++) {
                const next = allSlides[index + offset];
                if (!next) continue;

                collectImageUrlsFromSlide(next).forEach(preloadImage);
            }
        },
        { immediate: true },
    );
}
